import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import UserLogin from "./UserLogin";

export type LoginProps = {
    // Method that is called when the user login was successful
    onLoginSuccessful: () => void;
}

type LocationState = {
    from?: { pathname: string; search: string };
}

const Login = (props: LoginProps) => {
    const navigate = useNavigate();
    const location = useLocation();

    const onLoginSuccessful = useCallback(() => {
        props.onLoginSuccessful();
        const from = (location.state as LocationState | null)?.from;
        navigate(from ? `${from.pathname}${from.search}` : '/', { replace: true });
    }, [props, navigate, location.state]);

    return <UserLogin onLoginSuccessful={onLoginSuccessful} />;
}

export default Login;
